import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import './ExploreUnknownLevel100DoorToast.css';

/**
 * One-time centered message when account Explore Unknown level reaches 100.
 *
 * @param {{ onDismiss: () => void }} props
 */
export default function ExploreUnknownLevel100DoorToast({ onDismiss }) {
  const { t } = useTranslation();
  const [phase, setPhase] = useState('enter');
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    const t0 = window.setTimeout(() => setPhase('shown'), 60);
    return () => window.clearTimeout(t0);
  }, []);

  const dismiss = useCallback(() => {
    setPhase('exit');
    window.setTimeout(() => onDismissRef.current(), 380);
  }, []);

  const root = (
    <div
      className={`eu-level100-door-toast${phase === 'exit' ? ' eu-level100-door-toast--exit' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="eu-level100-door-toast-message"
      onClick={(e) => {
        if (e.target === e.currentTarget) dismiss();
      }}
    >
      <div className="eu-level100-door-toast-backdrop" aria-hidden="true" />
      <div className="eu-level100-door-toast-card">
        <p id="eu-level100-door-toast-message" className="eu-level100-door-toast-message">
          {t('exploreUnknownPage.level100DoorUnlockedMessage')}
        </p>
        <button type="button" className="eu-level100-door-toast-continue" onClick={dismiss}>
          {t('exploreUnknownPage.level100DoorUnlockedContinue')}
        </button>
      </div>
    </div>
  );

  if (typeof document === 'undefined') {
    return root;
  }
  return createPortal(root, document.body);
}
